import { Component } from '@angular/core';
import { first, map } from 'rxjs/operators';
import { User } from '../models';
import { UserService, AuthenticationService, DealerService, SpinnerService } from '../services';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TopLayoutComponent } from '../layouts/top-layout.component';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';
import { trigger, state, style, transition, animate } from '@angular/animations';
//import { validateConfig } from '@angular/router/src/config';
import { Subscription } from 'rxjs/Subscription';
import { Dealer, DealerSourceMapping } from '../models';
import { filter, pairwise } from 'rxjs/operators';
import { LeftmenuLayoutComponent } from '../layouts/leftmenu-layout.component';
import { TableModule } from 'primeng/table';

@Component({
    templateUrl: 'subscribers-list.component.html',
    animations: [
        trigger('rowExpansionTrigger', [
            state('void', style({
                transform: 'translateX(-10%)',
                opacity: 0
            })),
            state('active', style({
                transform: 'translateX(0)',
                opacity: 1
            })),
            transition('* <=> *', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ]
})
export class SubscribersListComponent {
    users: User[] = [];
    dealers: any[];
    dealerCols: any;
    masterdealerCols: any;
    dealerSourceCols: any;
    Status: any;
    customMessage: any;
    public syncTopMenuClick: boolean = true;
    isFilelogsEnabled: boolean;
    isRed: boolean;
    searchText: any = "";
    searchDealers: boolean;
    topMenuBar: boolean;
    subscribers: any;
    subscriberCols: Object;
    scheduleOptions: any;
    displaySubDltDialog: boolean;
    selectedClientSubscriptionId: any;
    currentUser: User;
    toggleClass: string = "fa fa-angle-double-down";
    show: boolean= false;
    clients: any;
    client: any = -1;
   
    constructor(private userService: UserService,
        private dealerService: DealerService,
        private router: Router,
        private spinnerService: SpinnerService,
        private ngxPermissionsService: NgxPermissionsService,
        private authenticationService: AuthenticationService,
        private http: HttpClient) { 
            authenticationService.topMenuBar.subscribe(value => {
                this.syncTopMenuClick = !value;
            });
        }

    ngOnInit() {
        this.spinnerService.start();
        this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
        this.isFilelogsEnabled = false;
        this.isRed = true;
        this.searchText = "";
        this.getClients();
        this.getSubscriptions();
    }
    bindClientSubscriptionsInfo() {
        this.spinnerService.start();
        this.getSubscriptions();
    }
    Leftmenuclick() {
        this.topMenuBar = !this.topMenuBar;
        this.authenticationService.topMenuBar.next(this.topMenuBar);
    }
    getSubscriptions(){       
        this.dealerService.getAllSubscriptions(this.searchText,this.client).pipe(first()).subscribe(subscribers => {
            if (subscribers) {
                this.subscribers = subscribers;
                this.subscribers.forEach(element => {
                   let s= JSON.parse(element.ScheduleOptions);
                   element.ScheduleType = s.FrequencyOptions.Id
                });
                this.http.get('assets/data/subscriber-header.json').subscribe(results => {
                    this.subscriberCols = results;
                    this.spinnerService.stop();
                });
            }
            else {
                this.customMessage = "No recors found";
                this.spinnerService.stop();
            }
        });
    }
    getClients(){
        this.dealerService.getClients().pipe(first()).subscribe(clients => {
            this.clients  = clients;
        });
    }
    AddSubscriber(guid){
        this.router.navigate(['/subscriptions/es', guid]);
    }
    onDeleteSubscription(ClientSubscriptionId){
        this.displaySubDltDialog = true;
        this.selectedClientSubscriptionId = ClientSubscriptionId
        
    }
    Yes(){
        this.spinnerService.start();
        this.dealerService.delSubscription(this.selectedClientSubscriptionId,this.currentUser.userName).pipe(first()).subscribe(data => {
            this.subscribers = this.subscribers.filter(item => item.ClientSubscriptionId !== this.selectedClientSubscriptionId)
            this.displaySubDltDialog = false;
            this.spinnerService.stop();
        });
    }
    No(){
        this.displaySubDltDialog = false;
    }
    seachClick(show){
        if(show == false){
            this.toggleClass = 'fa fa-angle-double-down';
        }else{
            this.toggleClass = 'fa fa-angle-double-up';
        }
    }
    getDealersList(guid){
        this.router.navigate(['/subscriptions/dealer-list', guid]);
    }
    
}